<template>
  <div
    :class="['ten-input-group', {
      'ten-input-group__collapse': collapse
    }]"
  >
    <!-- @slot  input组件-->
    <slot />
  </div>
</template>

<script>
const name = 'ten-input-group';
export default {
  name,
  provide() {
    return {
      group: this,
    };
  },
  props: {
    /**
     * 是否合并input框
     */
    collapse: { type: Boolean, default: false },
    /**
     * 尺寸
     *
     * @member default | small
     */
    size: { type: String, default: 'default', validator(v) {
      return ['default', 'small'].indexOf(v) > -1;
    } },
  },
};
</script>
